import React, { Component } from 'react';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isEmptyArrayOrObject, isFunction, isXSmallResolution, noop } from '@philips-internal/oswald-ui-utils';
import { Swipe } from '../../../swipe/swipe.js';
import { getEnabledOptions } from '../heading-context/heading-context-utils.js';
import { InternalHeadingOptions } from './internal/internal-heading-options.js';
import './heading-options.css';
class HeadingOptions extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onClick = () => {
            this.setState({ open: true });
        };
        this.onClose = () => {
            this.setState({ open: false });
        };
    }
    componentDidUpdate() {
        const { open } = this.state;
        if (open && this.shouldRenderMobile()) {
            this.popNavigationItem = this.context?.pushNavigationItem(this.onClose);
        }
    }
    componentWillUnmount() {
        if (isFunction(this.popNavigationItem)) {
            this.popNavigationItem();
        }
    }
    triggerAndClose(action) {
        action.onClick(new ClickEvent());
        this.onClose();
        if (this.shouldRenderMobile() && isFunction(this.popNavigationItem)) {
            this.popNavigationItem();
        }
        this.closeParent();
    }
    closeParent() {
        const { parent } = this.props;
        if (!parent) {
            return;
        }
        const { onClose = noop, popNavigationItem = noop } = parent;
        onClose();
        popNavigationItem();
    }
    shouldRenderMobile() {
        return isXSmallResolution();
    }
    renderItems() {
        const { actions } = this.props;
        return (React.createElement("div", { className: "c-heading-options__items" }, actions.map(action => {
            return this.renderItem(action);
        })));
    }
    renderItem(action) {
        const { id, text = '', options } = action;
        const enabledOptions = getEnabledOptions(options);
        if (!isEmptyArrayOrObject(enabledOptions)) {
            const parent = {
                action,
                onClose: () => this.triggerAndClose(action),
                popNavigationItem: this.popNavigationItem,
            };
            return (React.createElement(HeadingOptions, { actions: enabledOptions, key: id, parent: parent }));
        }
        let item = (React.createElement("div", { className: "c-heading-options__item", key: id, onClick: () => this.triggerAndClose(action) },
            React.createElement("span", null, MessageService.translate(text))));
        if (action.swipeActions && this.shouldRenderMobile()) {
            item = (React.createElement("div", { className: "c-heading-options__item-swipe", key: id },
                React.createElement(Swipe, { actions: action.swipeActions }, item)));
        }
        return item;
    }
    render() {
        const { parent } = this.props;
        const { open } = this.state;
        return (React.createElement(InternalHeadingOptions, { onClick: this.onClick, onClose: this.onClose, open: open, parent: parent }, this.renderItems()));
    }
}
HeadingOptions.contextType = ApplicationContext.Context;
export { HeadingOptions, };
//# sourceMappingURL=heading-options.js.map